import React from 'react'
import cx from 'classnames'

import s from './Flex.scss'


type Justify = 'space-between' | 'space-around' | 'center'

type FlexProps = {
  children: React.ReactNode
  className?: string
  justify?: Justify
  onClick?: Function
}

const Flex: React.FunctionComponent<FlexProps> = ({ children, className, justify, onClick }) => {
  const rootClassName = cx(s.flex, className, {
    [s[`justify-${justify}`]]: justify,
  })

  return (
    <div className={rootClassName} onClick={onClick}>
      {children}
    </div>
  )
}


export default Flex
